import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Menu, MenuItem, IconButton, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signOut } from "firebase/auth";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [user, setUser] = useState(null);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => setUser(currentUser));
    return () => unsubscribe();
  }, [auth]);

  const handleMenuOpen = (event) => setMenuAnchor(event.currentTarget);
  const handleMenuClose = () => setMenuAnchor(null);

  const handleLogin = async () => {
    handleMenuClose();
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Error logging in:", error);
    }
  };

  const handleLogout = async () => {
    handleMenuClose();
    try {
      await signOut(auth);
      setUser(null);
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Box component={Link} to="/" sx={{ flexGrow: 1 }}>
          <img style={{ width: "90%", maxWidth: "150px", paddingTop: "5px", paddingBottom: "5px" }} src="/images/logo.png" alt="logo" />
        </Box>

        <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleMenuOpen}>
          <MenuIcon />
        </IconButton>

        <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleMenuClose}>
          <MenuItem onClick={handleMenuClose} component={Link} to="/">Home</MenuItem>
          <MenuItem onClick={handleMenuClose} component={Link} to="/sheet/">Sheets</MenuItem>

          {user && (
            <MenuItem onClick={handleMenuClose} component={Link} to="/sheet/add">
              Add sheet
            </MenuItem>
          )}

          {user ? (
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          ) : (
            <MenuItem onClick={handleLogin}>Login</MenuItem>
          )}
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
